import { IIconBase } from '..'

const toggleOffIcon = ({
  color = '#292D32',
  height = 22,
  width = 22,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/toggle-off'>
        <g id='toggle-off'>
          <path
            id='Vector'
            d='M7.60866 14.6673H9.80866C11.642 14.6673 12.3753 13.934 12.3753 12.1007V9.90065C12.3753 8.06732 11.642 7.33398 9.80866 7.33398H7.60866C5.77533 7.33398 5.04199 8.06732 5.04199 9.90065V12.1007C5.04199 13.934 5.77533 14.6673 7.60866 14.6673Z'
            fill='#A1A7C4'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M15.583 18.3327H6.41634C2.74967 18.3327 1.83301 17.416 1.83301 13.7493V8.24935C1.83301 4.58268 2.74967 3.66602 6.41634 3.66602H15.583C19.2497 3.66602 20.1663 4.58268 20.1663 8.24935V13.7493C20.1663 17.416 19.2497 18.3327 15.583 18.3327Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default toggleOffIcon
